import { BACKEND_URL } from '@/constants';
import { MicrodataType } from '@/types';

type ProductSchemaProps = {
  microdata: MicrodataType;
  description?: string;
  objectName?: string;
  ratingValue?: number;
  ratingCount?: number;
  reviewCount?: number;
};

type ProductSchemaType = {
  '@context': string;
  '@type': string;
  name: string;
  image: string;
  description: string;
  brand: {
    '@type': string;
    name: string;
  };
  aggregateRating?: {
    '@type': string;
    ratingValue: string;
    ratingCount: string;
    reviewCount: string;
  };
};

export const ProductSchema = ({
  microdata,
  description,
  objectName,
  ratingValue,
  ratingCount,
  reviewCount,
}: ProductSchemaProps) => {
  const getAbsoluteImageUrl = (image?: string) => {
    if (!image) return '';
    if (image.startsWith('http://') || image.startsWith('https://'))
      return image;
    if (!BACKEND_URL) return image;
    return `${BACKEND_URL}${image}`;
  };

  const ratingValueStr =
    ratingValue !== undefined ? String(ratingValue) : '4.9';
  const ratingCountStr = ratingCount !== undefined ? String(ratingCount) : '16';
  const reviewCountStr = reviewCount !== undefined ? String(reviewCount) : '16';

  const schema: ProductSchemaType = {
    '@context': 'http://schema.org/',
    '@type': 'Product',
    name: microdata.name || '',
    image: getAbsoluteImageUrl(microdata.image),
    description: description || '',
    brand: {
      '@type': 'Brand',
      name: objectName || '',
    },
  };

  // Добавляем рейтинг только если хотя бы одно значение передано явно
  if (
    ratingValue !== undefined ||
    ratingCount !== undefined ||
    reviewCount !== undefined
  ) {
    schema.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: ratingValueStr,
      ratingCount: ratingCountStr,
      reviewCount: reviewCountStr,
    };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};
